/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Dialog } from 'primereact/dialog';
import { InputText  } from 'primereact/inputtext';
import { TabMenu } from 'primereact/tabmenu';

import { LANGUAGE_DEFAULT } from '@constants/general';

class ComodinModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      activeTabIndex: 0,
      comodin: '',
      descriptionsValueEdit: null,
      errors: []
    }
  }

  componentDidMount() {
    const { keysLenguages, descriptionsValue } = this.props

    keysLenguages.map((item) =>
      this.setState({ [item]: { 
        descripcion: descriptionsValue ? descriptionsValue[item] || '' : ''
      } })
    );
    this.setState({
      comodin: this.props.value || '',
      loadingPage: false
    })
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { onContinueAction, onHidden, keysLenguages } = this.props
    const { comodin } = this.state
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return true
    let formatComodin = '$' + comodin
    const descripcion = keysLenguages.reduce((accum, item) => {
      if (this.state[item].descripcion) accum[item] = this.state[item].descripcion;
      return accum;
    }, {});
    onContinueAction({comodin: formatComodin, descripcion})
    return onHidden()
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFieldsReject = async () => {
    const { t, label, isAdd, allComodines, index } = this.props
    const { comodin } = this.state
    const { descripcion } = this.state[LANGUAGE_DEFAULT]

    let errors = {}
    if (!comodin) errors = { ...errors, 'comodin': `${t( label || 'Comodín')} ${t('es requerido')}`}
    else if (isAdd) {
      const existComodin = allComodines.find(item => item.comodin === `$${comodin}`)
      if (existComodin) errors = { ...errors, 'comodin': `${t( label || 'Comodín')} ${t('ya esta registrado')}`}
    } else if (!isAdd) {
      const existComodinIndex = allComodines.findIndex(item => item.comodin === `$${comodin}`)
      if (existComodinIndex !== index && existComodinIndex >= 0)  {
        errors = { ...errors, 'comodin': `${t( label || 'Comodín')} ${t('ya esta registrado')}`}
      }
    }
    if (!descripcion) errors = {...errors, [`${LANGUAGE_DEFAULT}-descripcion`]: `${t('Descripción')} ${t('es requerido')}`}

    this.setState({errors})
    return errors
  }

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  isFormFieldValid = (name) =>
    !!(this.state.errors[name]);

  getFormErrorMessage = (name) =>
    this.isFormFieldValid(name) && (
      <small className="p-error">{this.state.errors[name]}</small>
    );
  
  render () {
    const { t, display, title, onHidden, label, btnOkLabel, description, itemsTabsLenguages, keysLenguages } = this.props
    const { comodin, activeTabIndex, loadingPage } = this.state

    const renderByTabLenguage = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      return (
          <div className="p-col-12 p-field">
            <label htmlFor="title" className="p-text-bold">
              {t('Descripción', {lng: prefixLenguage })}
            </label>
            <InputText
              name={`${prefixLenguage}-descripcion`}
              type="text"
              value={this.state[prefixLenguage].descripcion}
              onChange={this.onChange}
              autoFocus
              className={classNames({
                'p-invalid': this.isFormFieldValid(`${prefixLenguage}-descripcion`),
              })}
            />
            {this.getFormErrorMessage(`${prefixLenguage}-descripcion`)}
          </div>
      );
    }

    const children = loadingPage ? '' : (
      <form className="p-mt-2 p-fluid" onSubmit={this.onSubmit}>
        <div className="p-col">
          <label className="">{label || t('Comodín')}</label>
        </div>
        <div className="col-12 md:col-4">
            <div className="p-inputgroup">
                <span className="p-inputgroup-addon">$</span>
                <InputText
                  name="comodin"
                  onChange={(e) =>
                    this.setState({ comodin: e.target.value }, this.validateFieldsOnchange('comodin', e.target.value))
                  }
                  value={comodin}
                  className={classNames({
                    'p-invalid': this.isFormFieldValid(`comodin`),
                  })}
                />
            </div>
        </div>
        {this.getFormErrorMessage(`comodin`)}
        <div className="p-col-12">
          {itemsTabsLenguages && (
            <TabMenu
              model={itemsTabsLenguages}
              activeIndex={activeTabIndex}
              onTabChange={(e) =>
                this.setState({ activeTabIndex: e.index })
              }
            />
          )}
          {renderByTabLenguage()}
        </div>
        <div className="p-col">
          <label className="">{description}</label>
        </div>
        <div className="p-dialog-footer custom">
          <div>
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">Cerrar</span>
            </button> 
            <button className="p-button p-component" type="submit">
              <span className="p-button-label p-c">{btnOkLabel || 'Continuar'}</span>
            </button>
          </div>
        </div>
      </form>
    )
    if (loadingPage) return true;

    return (
      <Dialog
        header={title || t('Comodín')}
        visible={display}
        breakpoints={{'960px': '90vw'}}
        style={{ width: '30vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => ({
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  keysLenguages: state.catalogs.keysLanguageCatalog,
});

const mapDispatchToProps = {
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps))(ComodinModal)